import { useRef as p, useCallback as d, useEffect as l } from "react";
import { useAvailabilities as h } from "./index145.mjs";
import { useOnScreen as v } from "./index150.mjs";
import "jotai";
import "@amenitiz/design-system";
const C = () => {
  const a = p(null), s = v(a), {
    months: r,
    fetchAvailabilities: o,
    findNextDateToLoad: n,
    isReachLimit: e,
    isWithinLimit: c,
    checkIfAvailable: f,
    getAvailabilityForDate: m,
    getFirstUnavailableDate: b,
    timeLimitCustomMessage: u
  } = h(), i = d(
    async (t = {}) => {
      await o(t);
    },
    [o]
  );
  return l(() => {
    i();
  }, [i]), l(() => {
    if (s && !e) {
      const t = n();
      i({ startDate: t });
    }
  }, [s, e]), {
    loaderRef: a,
    isReachLimit: e,
    months: r,
    isWithinLimit: c,
    checkIfAvailable: f,
    getAvailabilityForDate: m,
    getFirstUnavailableDate: b,
    timeLimitCustomMessage: u
  };
};
export {
  C as useLoadScrollableCalendar
};
